export default {
  errMsgMain: 'mx-10 md:mx-0 float-left',
  regMainSec:
    'flex w-12/12 mx-auto border-t-1 border-lightGrey border-solid mb-100 px-16 md:px-0',
  parenteditMainSec:
    'flex w-12/12 mx-auto border-t-1 border-lightGrey border-solid',
  imageLeft: 'w-6/12 hidden md:block pr-80',
  formHeading:
    'font-BornreadyRegular text-black text-24 md:text-36 pt-50 leading-60 font-normal',
  formSubHeading:
    'font-BebasNeueBold text-black text-20 md:text-24 pt-0 md:pt-5 leading-36 mb-0',
  formEditSubHeading:
    'font-BebasNeueBold text-black text-20 md:text-24 pt-0 md:pt-5 leading-36 mb-35',
  regSteps:
    'font-HelveticaNeueLight text-14 leading-24 text-black regPoints relative pl-22',
  regStepsMain: 'pt-0 md:pt-33 pb-50',
  regName: 'relative w-full md:w-6/12 regName pr-0 md:pr-15',
  regLastName: 'relative w-full md:w-6/12 regName pt-20 md:pt-0 pr-0 md:pr-15',
  regNameMain: 'flex flex-wrap mb-35',
  regGenHead:
    'font-HelveticaNeueLight text-14 leading-20 text-black pb-10 mx-0',
  regGenMain: 'regGenCheck mb-40',
  dobMain: 'dobMain flex mb-40',
  regBtnMain: 'w-full text-center md:text-left',
  regBtn:
    'py-11 w-204 mt-20 px-29 font-BebasNeueBold text-20 leading-24 text-center border-2 border-black border-solid',
  loginMainSec:
    'flex flex-col md:flex-row w-12/12 mx-auto border-t-1 border-lightGrey border-solid mb-100 md:px-0',
  loginImageLeft:
    'md:w-6/12 md:block h-34v md:h-auto overflow-hidden md:overflow-auto',
  loginName: 'relative w-full md:w-9/12 regName pr-0',
  loginNameMain: 'flex flex-wrap mt-35',
  formLoginHeading:
    'font-BornreadyRegular text-black text-24 md:text-36 pt-50 leading-60 w-full text-center md:text-left font-normal',
  formLoginSubHeading:
    'font-BebasNeueBold text-black text-20 md:text-24 pt-0 md:pt-5 leading-36 mb-0 text-center md:text-left',
  forgotPasswordMain: 'relative w-full md:w-9/12 pt-12 pr-0 pb-60 text-right',
  forgotPasswordLink:
    'font-HelveticaNeueBold text-termGold text-14 md:text-14 pt-0 leading-16',
  changePasswordNextbutton: '',
  changePasswordSuccess:
    'text-center md:text-left font-play-fairdisplay-regular mb-30 mt-40 md:mt-55 md:mb-25 text-gray-dark  text-50 md:text-62 leading-55 md:leading-68 font-normal',
  changePasswordSuccessMessage:
    'text-center md:text-left block w-full font-spectral-medium text-18 leading-28 text-gray-dark font-normal mb-34 md:mb-6 md:w-7/12',
  forgetPwdMain: 'flex flex-wrap mt-35 mb-30',
  passwordResetText:
    'font-BebasNeueBold text-black text-20 md:text-24 pt-50 md:pt-35p leading-36 mb-0 text-center md:text-left',
  enterEmailText:
    'font-HelveticaNeueLight text-14 leading-24 text-black block pb-10 pt-15 mx-0 text-center md:text-left',
  thankyouText:
    'font-BebasNeueBold text-black text-20 md:text-24 pt-50 md:pt-45p leading-36 mb-0 text-center md:text-left',
  receiveEmailText:
    'font-HelveticaNeueLight text-14 leading-24 text-black block pb-10 pt-15 mx-0 text-left',
  tryAgain: 'font-HelveticaNeueBold text-termGold text-14 px-5',
  resetPwd: 'relative w-full md:w-8/12 regName pr-0 resetPwdInput',
  changePwdText:
    'font-BebasNeueBold text-black text-20 md:text-24 pt-50 md:pt-28.1p leading-36 mb-0 text-center md:text-left',
  loginBackBtn:
    'py-11 w-204 mt-20 px-29 font-BebasNeueBold text-20 leading-24 text-center border-2 border-black border-solid block mx-auto mt-50 md:mt-70 md:mx-0',
  pwdInfoMsg:
    'font-HelveticaNeueLight text-12 leading-16 text-darkGrey w-full md:w-8/12',
  regGenMainWithInfo: 'regGenCheck',
  hidShowPopMain: 'mb-40',
  hidShowPopStaticTxt:
    'font-HelveticaNeueLight text-12 leading-16 text-darkGrey  w-full md:w-8/12',
  hidShowPopDataOne:
    'font-HelveticaNeueMedium text-termGold text-12 md:text-12 pt-0 leading-20',
  hidShowPopDataTwo:
    'font-HelveticaNeueLight text-12 leading-16 text-darkGrey w-full md:w-12/12',
  editMainSec:
    'w-full md:w-6/12 md:mx-auto md:mb-60 pt-40 md:pt-60 px-15 md:px-0',
  editPopName: 'relative w-full md:w-12/12 regName pr-0 md:pr-15',
  editResetBtnMain: 'w-full text-center md:text-center',
  pwdPopBtn:
    'font-HelveticaNeueBold text-termGold text-14 md:text-14 pt-0 leading-16',
  editPwdNamePopMain: 'mb-35',
  editPwdNamePop:
    'font-HelveticaNeueLight text-14 leading-20 text-black pb-10 mx-0',
  dobLabel: 'dobLabel',
  editResetBtn:
    'py-11 w-204 mt-20 px-29 font-BebasNeueBold text-20 bg-white leading-24 text-center border-2 border-black border-solid',
  childRejectMain: 'highFrame  blocked-backdrop container flex ',
  childRejectDiv:
    'blocked-message blocked-message block w-8/12 mx-auto mt-100 pt-70 font-lato-regular text-center text-20 leading-26',
  editProfileBtn: 'no-underline block w-full text-center md:text-left',
  ediProfileSuccessBtn: 'btn btn-solid',
  ediProfileSuccessOne:
    'text-center md:text-left font-sans-roma mb-30 md:mb-25 text-gray-dark text-5xl md:leading-64 font-normal',
  ediProfileSuccessTwo:
    'text-center md:text-left block w-full font-spectral-medium text-18 leading-28 text-gray-dark font-normal mb-34 md:mb-6',
  forgetPwdErrorMsg: 'float-left clear-both -mt-15',
  forgotPasswordSuccess:
    'w-full md:w-5/12 md:mx-0 md:mb-60 px-16 md:pl-80 md:pr-0',
  changePwdPop: 'changePwdPop',
  hiddenClass: 'hidden',
  terms:'termsConfirm',
  termsConfirm:'font-HelveticaNeueBold text-termGold text-14 termAnchorTag md:text-14 pt-0 leading-16 -ml-25',
  emailOptIn:"emailopt",
  emailInput:'mr-5 mt-3'
};
